export function shuffle(arr) {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function uniqueArray(arr) {
  return Array.from(new Set(arr));
}

export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}